export default __webpack_public_path__ + "static/day-4-d3c58ad32b961d64b5dd1bf08cc8d569.gif";